import { components } from "@certn/legacy-api/generated-schemas/people";

import { maximumXEmploymentReferencesRule as MAXIMUM_EMPLOYMENT_REFERENCES } from "./maximumXEmploymentReferencesRule";
import { requestedInternationalAddressesRule as REQUESTED_INTL_ADDRESSES } from "./requestedInternationalAddressesRule";
import { requireAddressRule as REQUIRE_ADDRESS } from "./requireAddressRule";
import { requireAustralianAddressRule as REQUIRE_AUSTRALIAN_ADDRESS } from "./requireAustralianAddressRule";
import { requireCanadianAddressRule as REQUIRE_CANADIAN_ADDRESS } from "./requireCanadianAddressRule";
import { requireCredentialsRule as REQUIRE_CREDENTIALS } from "./requireCredentialsRule";
import { requireEducationRule as REQUIRE_EDUCATION } from "./requireEducationRule";
import { requireEmploymentAddressRule as REQUIRE_EMPLOYMENT_ADDRESS } from "./requireEmploymentAddress";
import { requireEmploymentReferencesWithinXYearsRule as REQUIRE_EMPLOYMENT_REFERENCE_WITHIN_YEARS } from "./requireEmploymentReferencesWithinXYearsRule";
import { requireEmploymentsRule as REQUIRE_EMPLOYMENT } from "./requireEmploymentsRule";
import { requireUSAddressRule as REQUIRE_UNITED_STATES_ADDRESS } from "./requireUSAddressRule";
import { requireXEmploymentReferencesRule as REQUIRE_EMPLOYMENT_REFERENCES } from "./requireXEmploymentReferencesRule";
import { requireXYearsAddressHistoryRule as REQUIRE_X_YEARS_ADDRESS_HISTORY } from "./requireXYearsAddressHistoryRule";
import { requireXYearsEmploymentHistoryRule as REQUIRE_X_YEARS_EMPLOYMENT_HISTORY } from "./requireXYearsEmploymentHistoryRule";
import { ValidationRuleType } from "./types";

const rules: Partial<
  Record<components["schemas"]["ValidationRule"]["type"], unknown>
> = {
  REQUIRE_X_YEARS_EMPLOYMENT_HISTORY,
  REQUIRE_EMPLOYMENT_REFERENCES,
  REQUIRE_EMPLOYMENT_REFERENCE_WITHIN_YEARS,
  REQUIRE_EDUCATION,
  MAXIMUM_EMPLOYMENT_REFERENCES,
  REQUIRE_ADDRESS,
  REQUIRE_CANADIAN_ADDRESS,
  REQUIRE_X_YEARS_ADDRESS_HISTORY,
  REQUIRE_UNITED_STATES_ADDRESS,
  REQUIRE_AUSTRALIAN_ADDRESS,
  REQUIRE_CREDENTIALS,
  REQUESTED_INTL_ADDRESSES,
  REQUIRE_EMPLOYMENT,
  REQUIRE_EMPLOYMENT_ADDRESS,
};

export function getRule<T extends components["schemas"]["ValidationRule"]>(
  rule: T
) {
  if (!rule?.type) return;
  if (!rules[rule?.type]) {
    const error = `Missing implementation for ${rule?.type} rule`;
    console.error(error);
    return {
      rule: {} as T,
      isValid: () => false,
    };
  }

  return (rules[rule?.type] as (rule: T) => ValidationRuleType<T>)(rule);
}

function findRule<T extends components["schemas"]["ValidationRule"]>(
  field: components["schemas"]["SectionField"],
  ruleKey: string
) {
  return field?.validation_rules?.find((rule) => rule?.type === ruleKey) as T;
}

export function getValidationRule<
  T extends components["schemas"]["ValidationRule"],
>(field: components["schemas"]["SectionField"], ruleKey: string) {
  const validationRule = findRule<T>(field, ruleKey);

  return getRule<T>(validationRule);
}
